<script setup lang="ts">
import DOMPurify from "dompurify";
import { computed } from "vue";

const { html } = defineProps<{
  /** Untrusted HTML to render. */
  html: string | null | undefined;
}>();

const CONFIG = {
  ALLOWED_TAGS: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "br",
    "hr",
    "strong",
    "em",
    "u",
    "s",
    "ul",
    "ol",
    "li",
    "a",
    "img",
    "blockquote",
    "code",
    "pre",
  ],
  // we need to explicitly allow "target", because the default DOMPurify config strips it
  // but we want to allow the usage of target="_blank" for UX reasons
  // rel="noopener" is enforced for external links in modern browers since 2021
  ADD_ATTR: ["target"],
};

const isSupported = DOMPurify.isSupported;

const sanitizedHtml = computed(() => {
  if (!html) {
    return "";
  }

  if (!isSupported) {
    return "";
  }

  return DOMPurify.sanitize(html, CONFIG);
});
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-if="isSupported" v-html="sanitizedHtml"></div>
  <!-- When DomPurify is not supported, show the escaped html anyways,
 so we always show the text in case it has legal implications (e.g. consents) -->
  <div v-else>{{ html }}</div>
</template>
